import React from 'react';

export const SecondaryContent = ({ children }) => (
  <div className="xl:w-1/3 w-full flex flex-col xl:mt-0 mt-2 justify-start items-stretch h-full">
    { children }
  </div>
)

export default SecondaryContent;
